import React from 'react';
import { Box, Typography } from '@mui/material';
import { INumberInputFieldControlModeTemplate } from '@src/types/ControlModes';
import { ConfigTextField } from '../styles';
import { FormValue } from '../../context/formReducer';
interface NumberFieldProps {
  field: INumberInputFieldControlModeTemplate;
  fieldValue: FormValue | undefined;
  hasError: boolean;
  errorMessage: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const NumberField: React.FC<NumberFieldProps> = ({
  field,
  hasError,
  errorMessage,
  handleChange,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <ConfigTextField
        name={field.controllerField}
        value={field.defaultValue ?? ''}
        onChange={handleChange}
        variant='outlined'
        size='small'
        type='number'
        error={hasError}
        slotProps={{
          htmlInput: {
            style: { textAlign: 'center' },
            min: field.range?.min,
            max: field.range?.max,
          },
        }}
      />
      {hasError && (
        <Typography variant='caption' color='error'>
          {errorMessage}
        </Typography>
      )}
    </Box>
  );
};

export default NumberField;
